import { Plugin, AppContext } from '@jupiter-app/runtime';
import { ConfigParam, InitParam, TeaType } from './teaType';
import { Config } from './typings';

const defaultConfig = {
  name: 'default',
  channel: 'cn',
  log: process.env.NODE_ENV !== 'production',
  _staging_flag: 0,
  disable_auto_pv: false,
};

const pickParams = (config: any) => {
  const initParams: Record<string, unknown> = {};
  const configParams: Record<string, unknown> = {};

  const initParamsKeys = [
    'app_id',
    'channel',
    'channel_domain',
    'app_key',
    'log',
    'disable_ssid',
    'disable_webid',
    'disable_sdk_monitor',
    'checkExp',
    'disable_storage',
    'autotrack',
    'enable_stay_duration',
    'auto_profile',
    'disable_session',
    'event_verify_url',
    'enable_et_test',
    'enable_ab_test',
    'max_storage_num',
    'enable_storage',
    'enable_cookie',
    'enable_ab_visual',
    'cross_subdomain',
    'cookie_domain',
    'enable_multilink',
    'multilink_timeout_ms',
    'reportTime',
    'timeout',
    'max_report',
    'report_url',
    'maxDuration',
    'ab_channel_domain',
    'configPersist',
    'disable_auto_pv',
    'channel_type',
  ];

  Object.keys(config).forEach(key => {
    if (initParamsKeys.includes(key)) {
      initParams[key] = config[key];
    } else {
      configParams[key] = config[key];
    }
  });

  return {
    initParams: (initParams as any) as InitParam,
    configParams: (configParams as any) as ConfigParam,
  };
};

export default function runtimeTeaWrapper() {
  const runtimeTea = (_config: Config): Plugin => {
    const config = { ...defaultConfig, ..._config };

    const { name, useOverseaTea, useSlimTea, ...params } = config;

    const { initParams, configParams } = pickParams(params);

    let tracker: TeaType;

    if (process.browser) {
      if (useOverseaTea) {
        if (useSlimTea) {
          const {
            Collector,
          } = require('@dp/byted-tea-sdk-oversea/es/index-base.min');
          tracker = new Collector(name);
        } else {
          const { Collector } = require('@dp/byted-tea-sdk-oversea');
          tracker = new Collector(name);
        }
      } else if (useSlimTea) {
        const { Collector } = require('byted-tea-sdk/es/index-base.min');
        tracker = new Collector(name);
      } else {
        const { Collector } = require('byted-tea-sdk');
        tracker = new Collector(name);
      }
      tracker.init(initParams);

      tracker.config(configParams);

      if (!config.disableAutoStart) {
        tracker.start();
      }
      window.Tea = tracker;
    }

    const plugin = (context: AppContext) => {
      if (process.browser) {
        // 在 context 实例上，挂载
        context.Plugins.Tea = tracker;
      } else {
        const noop = () => {
          return 'fake tea on node';
        };
        const fakeTea = noop as any;

        ['init', 'config', 'start', 'send', 'predefinePageView'].forEach(
          key => {
            fakeTea[key] = noop;
          },
        );
        context.Plugins.Tea = fakeTea;
      }

      return {
        name: '@jupiter-app/plugin-tea',
      };
    };

    plugin.__name__ = '@jupiter-app/plugin-tea';
    return plugin;
  };

  return runtimeTea;
}
